import Vue from 'vue'
import { IContentMostLikelyMorphologicCodesGrid } from '@/modules/configurationModule/detail/samples/mostLikelyDiagnoses/MostLikelyMorphologicCodes.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class MostLikelyMorphologicCodesConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<IContentMostLikelyMorphologicCodesGrid>> {
        const response = await this.axios.put(`/configuration/mostLikelyMorphologicCodes`, filterModel, { params })
        return response.data
    }
    async patchMostLikelyMorphologicCodesBatch(request: IContentMostLikelyMorphologicCodesGrid[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/mostLikelyMorphologicCodes/batch`, request)
        return response.data
    }
    async createMostLikelyMorphologicCodes(request: IContentMostLikelyMorphologicCodesGrid): Promise<IContentMostLikelyMorphologicCodesGrid> {
        const response = await this.axios.post(`/configuration/mostLikelyMorphologicCodes`, request)
        return response.data
    }
    async deleteMostLikelyMorphologicCodesBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/mostLikelyMorphologicCodes/batch`, { data: request })
        return response.data
    }
}

export const mostLikelyMorphologicCodesConfigurationServices = new MostLikelyMorphologicCodesConfigurationServices()
